import { z } from 'zod'

// Сотрудник из справочника хаба (read-проекция): telemost его не создаёт.
// subject — стабильный идентификатор SSO, им же оперируют приглашения.
export const EmployeeSchema = z.object({
  subject: z.string(),
  username: z.string(),
  fullName: z.string().optional(),
  departments: z.array(z.string()).default([]),
})
export type Employee = z.infer<typeof EmployeeSchema>

// Отображаемое имя: ФИО, а без него — логин (у свежесинканных ФИО может не быть).
export function employeeLabel(e: Pick<Employee, 'username' | 'fullName'>): string {
  return e.fullName?.trim() || e.username
}
